module.exports = __webpack_public_path__ + "media/purpose/purpose@2x-a248d94f.png";